import {
  ModalProps,
  createUseModal,
  useFormModal,
} from "@imminently/react/context/modals";
import { Button, Checkbox, FormControlLabel, Stack } from "@mui/material";

import { Icon } from "@/components/Icon";
import MultilineTextInput from "@/components/MultilineTextInput";
import PatientCardModal from "@/components/PatientCardModal";
import { PatientEncounter } from "@/resources/types";
import { encounterService } from "@/services";

const { useUpdate } = encounterService;

interface DischardPatientModalProps {
  encounter: PatientEncounter;
}

const DischardPatientModal = ({ props }: ModalProps<DischardPatientModalProps>) => {
  const { encounter } = props;

  const { mutateAsync, isLoading } = useUpdate();
  const { methods, notify, close } = useFormModal({
    mode: "all",
    defaultValues: {
      note: "",
      pending: false,
    },
  });

  const { control, handleSubmit, formState } = methods;

  const submit = (data: any) => {
    const note = { text: data.note };
    const status = data.pending ? "pendingDischarged" : "discharged";
    // Set status to discharged or pendingDischarged, submit note
    mutateAsync({
      id: encounter.id,
      payload: { status, note },
    }).catch(() => {
      notify.error("Failed to discharge patient");
    });
    close(true);
  };

  return (
    <PatientCardModal
      title="Discharge patient"
      encounter={encounter}
      onClose={() => close()}
    >
      <MultilineTextInput
        control={control}
        field="note"
        required
        label="Discharge notes..."
        rows={6}
      />

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
          <Checkbox
            {...control.register("pending")}
            defaultChecked={false}
          />
          <span>Mark as Pending</span>
        </Stack>
        
        <Button
          disabled={isLoading || !formState.isValid}
          color="success"
          startIcon={<Icon icon="outcome" />}
          onClick={handleSubmit(submit)}
        >
          Discharge patient
        </Button>
      </Stack>
    </PatientCardModal>
  );
};

export const useDischardPatientModal = createUseModal(DischardPatientModal);
